import React, { Component } from "react";
import { DataGrid, GridColumn, Panel, TextBox, ComboBox, LinkButton } from "rc-easyui";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { getFormattedDate } from "../../../helpers";
// import { Button } from "reactstrap";
const axios = require("axios");
export default class ViewNotice extends Component {
  static propTypes = {
    selectedRow: PropTypes.object,
    OnEditClick: PropTypes.func,
    onSelectionChange: PropTypes.func,
    permissions: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      // searchForm: {
      //   clientname: "",
      // },
      searchparam: {
        srchClient: "",
        srchStatus: true,
      },
      pageOptions: {
        pageOptions: {
          layout: [
            "list",
            "sep",
            "first",
            "prev",
            "next",
            "last",
            "sep",
            "refresh",
            "sep",
            "manual",
            "info",
          ],
        },
      },
    };
    this.refereshData = this.refereshData.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        pageOptions: {
          loading: true,
          pageOptions: {
            pageNumber: 1,
            pageSize: 10,
            layout: [
              "list",
              "sep",
              "first",
              "prev",
              "next",
              "last",
              "sep",
              "refresh",
              "sep",
              "manual",
              "info",
            ],
          },
        },
      },
      () => {
        this.refereshData();
      }
    );
  }

  async refereshData() {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    //console.log(pageNumber);
    //console.log(pageSize);
    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    var url =
      API_URL +
      "api/getpublishnotice?rows=" +
      pageSize +
      "&page=" +
      pageNumber +
      "&clientname=" +
      this.state.searchparam.srchClient +
      "&status=" +
      this.state.searchparam.srchStatus;
    // var url = API_URL + "api/priceplanspagination?row=10&page=0";

    this.setState({
      pageOptions: {
        pageOptions: {
          ...this.state.pageOptions.pageOptions,
        },
        loading: true,
      },
    });
    if (access_token != null) {
      axios
        .get(url, axiosConfig)
        .then((response) => {
          if (response.status === 200) {
            var data = response.data.rows;
            var total = response.data.total;

            this.setState({
              data: data,
              pageOptions: {
                pageOptions: {
                  pageSize: 20,
                  total: total,
                  pageList: Array.from(new Set([20, 50, 30, 100, total])).sort(
                    function (a, b) {
                      return a - b;
                    }
                  ),
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.refereshData();
      }
    }
  }
  handleChange(name, value) {
    let search = Object.assign({}, this.state.searchForm);
    search[name] = value;
    this.setState({ searchForm: search });
  }
  onPageChange(event) {
    delete event["refresh"];
    delete event["filterRules"];

    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.refereshData();
      }
    );
  }

  searchFieldOnChange(name, e) {
    let searchparam = Object.assign({}, this.state.searchparam);
    searchparam[name] = e;
    this.setState({ searchparam: searchparam });
  }

  render() {
    const searchparam = this.state.searchparam;
    return (
      <div>
        <Panel
          title='Published Notice List'
          bodyStyle={{ padding: 0 }}
          style={{ height: 567 }}
        >
          <div id='toolbar' className='datagrid-toolbar'>
            {this.props.permissions.includes("publish-notice-edit") ? (
              <span
                className='easyui-linkbutton l-btn l-btn-small l-btn-plain'
                iconcls='icon-edit'
                plain='true'
                onClick={this.props.OnEditClick}
                group=''
                id=''
              >
                <span className='l-btn-left l-btn-icon-left'>
                  <span className='l-btn-text'>Edit</span>
                  <span className='l-btn-icon icon-edit'>&nbsp;</span>
                </span>
              </span>
            ) : (
              ""
            )}
            {/* <TextBox
              style={{ width: "100" }}
              onChange={(e) => this.handleChange("clientname", e)}
            ></TextBox> */}
            {/* <ComboBox
              style={{ width: "100" }}
              data={this.props.clients}
              valueField='clientid'
              textField='organizationname'
              onChange={(e) => this.handleChange("clientname", e)}
              value={this.state.searchForm.clientname}
            ></ComboBox> */}
            {/* <span className='l-btn-text'>Client Name</span>&nbsp; */}
            <ComboBox
              style={{ width: 200 }}
              data={this.props.clients}
              placeholder="Client Name"
              valueField='organizationname'
              textField='organizationname'
              value={searchparam.srchClient}
              onChange={(e) => this.searchFieldOnChange("srchClient", e)}
            ></ComboBox>
            <span className='l-btn-text'>Status</span>&nbsp;
            <ComboBox
              data={this.props.enabled}
              valueField='value'
              textField='text'
              value={searchparam.srchStatus}
              editable={false}
              onChange={(e) => this.searchFieldOnChange("srchStatus", e)}
            ></ComboBox>
            &nbsp;
            <LinkButton
              iconCls='icon-search'
              plain
              onClick={this.refereshData}
            >
              Search By Client Name
            </LinkButton>
            {/* <Button
              type='button'
              color='primary'
              data-testid='loginbtn'
              size='sm'
              onClick={this.refereshData}
            >
              Search By Client Name
            </Button> */}
          </div>
          <DataGrid
            data={this.state.data}
            style={{ height: 500 }}
            selectionMode='single'
            {...this.state.pageOptions}
            pagination
            {...this.props.selectedRow}
            onSelectionChange={(selection) =>
              this.props.onSelectionChange(selection)
            }
            onPageChange={this.onPageChange.bind(this)}
          >
            <GridColumn
              field='rn'
              align='center'
              width='30px'
              cellCss='datagrid-td-rownumber'
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            />

            <GridColumn
              field='organaizationName'
              title='Client Name'
            ></GridColumn>
            <GridColumn field='noticeBody' title='Notice'></GridColumn>
            <GridColumn field='displayArea' title='Display Area'></GridColumn>
            <GridColumn
              field='startDate'
              title='Start Date'
              render={({ row }) => (
                <span>{getFormattedDate(row.startDate)}</span>
              )}
            ></GridColumn>
            <GridColumn
              field='endDate'
              title='End Date'
              render={({ row }) => <span>{getFormattedDate(row.endDate)}</span>}
            ></GridColumn>
          </DataGrid>
        </Panel>
      </div>
    );
  }
}
